import { Theme, ThemeProvider } from '@mint/ui';
import { AdminAppProps } from './admin-app-props';
import { AdminAppRoutes } from '../admin-app-routes';
import React from 'react';
import { admin } from '../../../themes/admin';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle<{ theme: Theme }>`
  html {
    background: ${props => props.theme.palette.background.default};
    background: var(${props => props.theme.palette.background.default});
  }
`;

export const AdminApp: React.FunctionComponent<
  AdminAppProps
> = (): React.ReactElement => {
  return (
    <ThemeProvider theme={admin}>
      <GlobalStyles />
      <AdminAppRoutes />
    </ThemeProvider>
  );
};

AdminApp.displayName = 'AdminApp';
